@use "../../sass/global/global" as *;

.ux-iws-nb-teaser-product {
    box-sizing: border-box;
    display: block;
    width: 100%;
    padding: 15px 0;
    line-height: 1.375;
    color: $color-black-1;

    @media (min-width: 568px) and (max-width: 767px) {
        padding: 15px;
    }

    @media (min-width: 768px) {
        padding: 30px 15px;
    }

    @media (min-width: 1024px) {
        padding: 30px 0;
    }

    &__grid {
        display: grid;
        gap: 30px;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        grid-template-areas:
            "image"
            "header"
            "tags"
            "description"
            "features"
            "cta";
    }

    &__image {
        grid-area: image;

        img {
            display: block;
            width: auto;
            max-width: 100%;
            aspect-ratio: 3 / 2;
            object-fit: cover;
        }
    }

    &__header {
        grid-area: header;

        h2,
        h3,
        h4 {
            @include nb-heading(3, false);
            margin-top: 0;
            margin-bottom: 10px;
            color: inherit;
        }
    }

    &__subtitle {
        div,
        p {
            font-size: 1rem; // 16px
            margin: 0;
            color: inherit;
            @include font(light);
        }
    }

    &__tags {
        @include nb-tag-list();
        margin: 0;
    }

    &__tag {
        @include nb-tag();

        &--highlighted {
            background-color: $color-blue-1;
            color: $color-white;
        }
    }

    &__description {
        grid-area: description;
        font-size: 0.875rem; // 14px
        line-height: 1.375;

        div,
        p {
            @include font(light);
            color: inherit;
            margin: 0;
        }
    }

    &__features {
        grid-area: features;
        @include font(light);
        font-size: 0.875rem;
        line-height: 1.375;

        ul {
            display: grid;
            grid-template-columns: 1fr 1fr;
            margin: 0;
            padding: 0;
            gap: 10px;
        }

        li {
            @include font(light);
            list-style: square outside;
            margin: 0 0 0 14px;
            padding: 0;
        }
    }

    &__cta {
        grid-area: cta;
    }
}

@media (max-width: 567px) {
    .ux-iws-nb-teaser-product ux-button {
        width: 100%;
        flex: 1 0 100%;
    }
}

@media (max-width: 767px) {
    .ux-iws-nb-teaser-product {
        &__image img {
            max-height: 320px;
        }
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .ux-iws-nb-teaser-product {
        &__image img {
            max-height: 400px;
        }
    }
}

@media (min-width: 768px) {
    .ux-iws-nb-teaser-product {
        &__grid {
            grid-template-columns: 1fr 1fr;
            grid-template-rows: auto auto auto auto 1fr;
            grid-template-areas:
                "image image"
                "header header"
                "tags tags"
                "description features"
                "cta features";
        }

        &__subtitle,
        &__subtitle p {
            font-size: 1.125rem; // 18px
        }

        &__features {
            border-left: 1px solid $color-black;
            padding-left: 10px;
        }

        &__description {
            font-size: 1rem;
        }
    }
}

@media (min-width: 1024px) {
    .ux-iws-nb-teaser-product {
        &__grid {
            grid-template-columns: 1fr 1fr;
            grid-template-rows: auto auto auto 1fr;
            grid-template-areas:
                "image header"
                "image tags"
                "image ."
                "description features"
                "cta features";
        }

        &__subtitle,
        &__subtitle p {
            font-size: 1.25rem; // 20px
        }

        &__features {
            font-size: 1rem;
        }
    }
}

@media (min-width: 1440px) {
    .ux-iws-nb-teaser-product {
        &__grid {
            grid-template-columns: 4fr 3fr 3fr;
            grid-template-rows: auto auto auto 1fr;
            grid-template-areas:
                "image header header"
                "image tags tags"
                "image description features"
                "image cta features";
        }

        &__subtitle,
        &__subtitle p {
            font-size: 1.4375rem; // 23px
        }

        &__features ul {
            grid-template-columns: 1fr;
        }
    }
}

@media (min-width: 1600px) {
    .ux-iws-nb-teaser-product {
        &__tags,
        &__description,
        &__cta {
            padding-left: 30px;
        }
    }
}
